import { Box, Button, Divider, Grid, TextField, Typography } from '@mui/material'
import React from 'react'
import Objetivos from '../formulario/Objetivos'
import { Save } from '@mui/icons-material'

const ObjetivosTab = ({ datos, setData, editable, imagenes, handleUpdate }) => {
    return (
        <Box sx={{ m: 2 }}>
            {
                editable ?
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Objetivos datos={datos} setDatos={setData} />
                            <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                                <Button variant="contained" color="success" startIcon={<Save />} onClick={handleUpdate} >Guardar esta sección</Button>
                            </Box>
                        </Grid>
                    </Grid>
                    :
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <Typography variant="h6">Propósitos por los que surgió la empresa</Typography>
                            <Typography sx={{ mx: 1, mt: 2 }}>{datos.proposito}</Typography>

                        </Grid>
                        <Grid item xs={12}>
                            <Divider />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h6">Factores que han favorecido el desarrollo de la empresa</Typography>
                            <ul>
                                {
                                    datos.factores.map((factor) => (
                                        <Typography sx={{ mx: 1, mt: 2 }} component="li">{factor}</Typography>
                                    ))
                                }
                            </ul>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h6">Organizaciones que han contribuido al fortalecimiento de la empresa</Typography>
                            <ul>
                                {
                                    datos.organizaciones.map((organizacion) => (
                                        <Typography sx={{ mx: 1, mt: 2 }} component="li">{organizacion}</Typography>
                                    ))
                                }
                            </ul>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h6">Resultados de la empresa - socioeconómicos y ambientales</Typography>
                            <ul>
                                {
                                    datos.resultados.map((resultado) => (
                                        <Typography sx={{ mx: 1, mt: 2 }} component="li">{resultado}</Typography>
                                    ))
                                }
                            </ul>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h6">Perspectivas de desarrollo y beneficios que puede generar la empresa</Typography>
                            <ul>
                                {
                                    datos.perspectivas.map((perspectiva) => (
                                        <Typography sx={{ mx: 1, mt: 2 }} component="li">{perspectiva}</Typography>
                                    ))
                                }
                            </ul>
                        </Grid>
                    </Grid>
            }
        </Box>
    )
}

export default ObjetivosTab